var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49992 5.66671C4.69654 5.66671 5.66658 4.69666 5.66658 3.50004C5.66658 2.30342 4.69654 1.33337 3.49992 1.33337C2.3033 1.33337 1.33325 2.30342 1.33325 3.50004C1.33325 4.69666 2.3033 5.66671 3.49992 5.66671Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 14.6666C4.43782 14.6666 5.33325 13.7712 5.33325 12.6666C5.33325 11.5621 4.43782 10.6666 3.33325 10.6666C2.22868 10.6666 1.33325 11.5621 1.33325 12.6666C1.33325 13.7712 2.22868 14.6666 3.33325 14.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 14.6666C13.7713 14.6666 14.6667 13.7712 14.6667 12.6666C14.6667 11.5621 13.7713 10.6666 12.6667 10.6666C11.5622 10.6666 10.6667 11.5621 10.6667 12.6666C10.6667 13.7712 11.5622 14.6666 12.6667 14.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.7799 10.6534C12.1333 8.80003 10.3866 7.55337 8.41992 7.55337C8.41325 7.55337 8.40659 7.55337 8.39992 7.55337L6.04659 7.56003C5.03325 7.57336 4.12659 6.8867 3.85325 5.90003V4.6667C3.85325 4.3867 3.62659 4.16003 3.33992 4.16003C3.05325 4.16003 2.83325 4.3867 2.83325 4.6667V12.1467C2.83325 12.4267 3.05992 12.6534 3.33992 12.6534C3.61992 12.6534 3.85325 12.4267 3.85325 12.1467V7.73337C4.43992 8.25337 5.20659 8.57336 6.03992 8.57336C6.04659 8.57336 6.04659 8.57336 6.05325 8.57336L8.40659 8.5667C8.41325 8.5667 8.41325 8.5667 8.41992 8.5667C9.94659 8.5667 11.3133 9.53336 11.8133 10.98C11.8866 11.1934 12.0866 11.32 12.2933 11.32C12.3466 11.32 12.4066 11.3134 12.4599 11.2934C12.7333 11.2134 12.8733 10.92 12.7799 10.6534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.bce18aaf6354c554a4d6feb2e2a5dc9b.svg";
export { ForwardRef as ReactComponent };